import '../../theme/global.scss';

const Line = ({ width }: { width: number | string }) => {
  return (
    <div className='line' style={{ width: width || 100, height: '3px' }}></div>
  );
};

const Space = ({
  vertical,
  horizontal
}: {
  vertical?: number | string | undefined;
  horizontal?: number | string | undefined;
}) => {
  return <div style={{ height: vertical || 0, width: horizontal || 0 }}></div>;
};

export { Line, Space };
